import React, {useEffect, useState} from "react";
import {getHostAddress, mainSet} from "../../Tool/UtileFun";
import {Button, Card, Input, message, Space, Table} from "antd";
import {TabButtons} from "./TabButtons";
import {getBackEndData} from "../../Tool/AxiosConnection"

export function ClassTable(){
    useEffect(
        ()=>{
            findAll()
            //findAllUntil()
            //conn()
        },[]
    );


    const conn = () =>{
        let data = getBackEndData({url:"http://localhost:8080/cclass/findAll",
            method:"post",
            data:"{}"})
        console.log(data)
        data.then(res=>{
            //setCClass(res)
            console.log(res.status)
        })
    }
    const findAllUntil = ()=>{
        let value = {
            address:"/cclass/findAll",
            json:{}
        }
        setCClass(mainSet(value))
    }



    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/findAll",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify("{}"),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCClass(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchClass=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/searchName",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({searchName:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCClass(data)
                console.log("search-------")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const deleteClass=()=>{
        console.log(classId)
    }

    let classId = ""

    const buttons = () =>{
        return(
            <>
                <Button type="primary" >编辑</Button>
                <Button type="primary" danger onClick={deleteClass}>删除</Button>
            </>
        )
    }


    const [cClass,setCClass]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '班级名称',
            dataIndex: 'className',
            key: 'className',
        },
        {
            title: '操作',
            key: 'details',
            render: (classInfo) => (
                <>
                    <Space size="middle">
                        <TabButtons props = {classInfo}
                                    Event={()=>{
                                        findAll()
                                    }}
                        ></TabButtons>
                    </Space>
                </>
            ),
        },

    ];

    let data = []

    return(
        <Card title={"班级管理"}>
            <Search placeholder="输入班级名称搜索"
                    onSearch={value => searchClass(value)}
                    enterButton
                    style={{width:500}}/>
            <Table
                columns={columns}
                dataSource={cClass}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
